import WarningIcon from '@core/assets/icons/warning.svg';

import classes from './TextArea.module.scss';

const TextArea = ({
	validation,
	input,
	errors,
	register,
	className,
	horizontal = false,
	hasError = true,
	hasLong = false,
}) => {
	return (
		<div
			className={`${horizontal ? 'row d-flex flex-row' : 'd-flex flex-column'} ${
				classes['textinput-wrapper']
			} ${className || ' '} ${hasLong ? classes["long"] : ' '}`}>
			<label htmlFor={input.id} className={`${horizontal ? 'col-12 col-xl-4' : ''}`}>
				{input.label}
			</label>
			<textarea
				className={`${(errors && errors[input.name] && classes['invalid']) || ''} ${
					horizontal ? 'col-12 col-xl-8' : ''
				} ${input.label ? '' : 'col-12 col-xl-12'}`}
				rows={6}
				{...input}
				{...register(input.name, validation)}
			/>
			{hasError && (
				<div>
					{errors[input.name] && errors[input.name].message && (
						<span>
							<WarningIcon /> {errors[input.name].message}
						</span>
					)}
				</div>
			)}
		</div>
	);
};

export default TextArea;
